import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import EventDetailPage from "@/pages/EventDetailPage";
import PageView from "@/pages/PageView";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEvents from "@/pages/AdminEvents";
import AdminPages from "@/pages/AdminPages";
import AdminOrders from "@/pages/AdminOrders";
import AdminSettings from "@/pages/AdminSettings";
import AdminContestEntries from "@/pages/AdminContestEntries";
import ContestPage from "@/pages/ContestPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AdminThemeProvider } from "@/contexts/AdminThemeContext";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
    <LanguageProvider>
    <AuthProvider>
      <div className="min-h-screen bg-[#0A0A0A]">
        <BrowserRouter>
          <ScrollToTop />
          <GoogleAnalytics />
          <AdminThemeProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<><Navbar /><HomePage /><Footer /></>} />
            <Route path="/event/:slug" element={<><Navbar /><EventDetailPage /><Footer /></>} />
            <Route path="/p/:slug" element={<PageView />} />
            <Route path="/checkout/success" element={<><Navbar /><CheckoutSuccess /><Footer /></>} />
            <Route path="/tavla" element={<ContestPage contestSlug="fotbollsmorgon" />} />
            <Route path="/tavla/scandsports" element={<ContestPage contestSlug="scandsports" />} />
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/events" element={<AdminEvents />} />
            <Route path="/admin/pages" element={<AdminPages />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/contest-entries" element={<AdminContestEntries />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Routes>
          </AdminThemeProvider>
        </BrowserRouter>
        <Toaster position="top-right" toastOptions={{ style: { background: '#141414', border: '1px solid #262626', color: '#FFFFFF', fontFamily: 'Outfit, sans-serif' } }} />
      </div>
    </AuthProvider>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
